var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getData, updateData, createData } from "../dataAccess";
import { getApiUrl } from "../../apiEndPoints";
// Get all trials
export const getTrials = (includeArchived) => __awaiter(void 0, void 0, void 0, function* () {
    let url = `Trials/trials`;
    if (includeArchived) {
        url = url + `?includeArchived=true`;
    }
    return getData(url);
});
//single trial
export const getTrial = (trialID, signal) => __awaiter(void 0, void 0, void 0, function* () {
    const url = `Trials/trial?trialID=${trialID}`;
    const resp = yield getData(url, signal);
    if (resp.status === 200 && Array.isArray(resp.data) && resp.data.length > 0) {
        resp.data.forEach((trial) => {
            if (typeof trial.trialDocuments === 'string') {
                try {
                    trial.trialDocuments = JSON.parse(trial.trialDocuments);
                }
                catch (error) {
                    console.error("Error parsing trialDocuments:", error);
                    trial.trialDocuments = [];
                }
            }
            if (Array.isArray(trial.trialDocuments)) {
                trial.trialDocuments.forEach((doc) => {
                    if (!doc.url || !doc.url.startsWith("https://")) {
                        doc.url = `${getApiUrl()}Trials/trial-document?ID=${doc.id}`;
                    }
                });
                console.log("Processed trialDocuments:", trial.trialDocuments);
            }
        });
    }
    return resp;
});
//trialDocuments 
export const getTrialDocuments = (trialID) => __awaiter(void 0, void 0, void 0, function* () {
    const url = `Trials/trial-documents?trialID=${trialID}`;
    return getData(url);
});
//trialDocument Delete 
export const deleteTrialDocument = (trialDocument) => __awaiter(void 0, void 0, void 0, function* () {
    const url = `Trials/trial-document-delete`;
    return updateData(url, trialDocument);
});
const BaseUrl = getApiUrl();
export const createTrialDocument = (formData) => __awaiter(void 0, void 0, void 0, function* () {
    const url = `${BaseUrl}Trials/trial-document-create`;
    let apiResponse = {
        status: 0,
        message: "",
        data: false,
    };
    try {
        const response = yield fetch(url, {
            method: "POST",
            headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
            body: formData,
        });
        apiResponse.status = response.status;
        apiResponse.message = response.statusText;
        if (!response.ok) {
            return apiResponse;
        }
        apiResponse.data = true;
        return apiResponse;
    }
    catch (error) {
        apiResponse.status = 500;
        if (error instanceof Error) {
            apiResponse.message = error.message;
        }
        else {
            apiResponse.message = "An unknown error occurred";
        }
        return apiResponse;
    }
});
export const createTrialExternalUrl = (trialExternalUrl) => __awaiter(void 0, void 0, void 0, function* () {
    const url = `Trials/trial-external-url-create`;
    return createData(url, trialExternalUrl);
});
export const getTrialResultTable = (trialID, categoryID) => __awaiter(void 0, void 0, void 0, function* () {
    if (categoryID === "")
        categoryID = undefined;
    const url = `TrialResults/trialresulttable?trialID=${trialID}` + (categoryID ? `&categoryID=${categoryID}` : "");
    return getData(url);
});
// Create a new trial
export const createTrial = (trial) => __awaiter(void 0, void 0, void 0, function* () {
    const url = `Trials/trials-create`;
    //remove from the object if the value is null or undefined
    Object.keys(trial).forEach((key) => trial[key] == null && delete trial[key]);
    console.log("Before create: ", trial);
    return createData(url, trial);
});
// Update an existing trial
export const updateTrial = (trial) => __awaiter(void 0, void 0, void 0, function* () {
    const url = `Trials/trial-update`;
    return updateData(url, trial);
});
// Delete a trial
export const deleteTrial = (trial) => __awaiter(void 0, void 0, void 0, function* () {
    const url = `Trials/trials-delete`;
    return updateData(url, trial);
});
